module.exports = __webpack_public_path__ + "static/media/portabilite.efaaa813.jpg";